import React from 'react';
import {Button, Icon} from 'semantic-ui-react';
import {FormattedMessage} from "react-intl";
import {Form, Grid, Label, Loader} from "semantic-ui-react";
import catchErrors from 'hoc/catchErrors';

/*
This is like a render prop component.
The stuff that gets rendered is in the field definition. This pulls in the current resource and passes it along to be rendered.
This allows us to do kooky one-off things instead of defining a field for everything.

Usage:

    fields: [
        {
            type: 'resourceJsx',
            name: 'reportLink',     // doesn't matter

            props: {
                jsx: (resource) => {
                    // console.log(`leadgen`, resource)
                    return (
                        <React.Fragment>
                            { resource && 
                                <a href={`${Config.BEAKER2_URL}#/leadgen/${resource.id}/show/`} target="_leadgen">Report on Beaker2 <i class="external alternate icon small"/></a> 
                            }
                        </React.Fragment>
                        
                    )
                }
            }
        },


*/
class ResourceJsx extends React.Component {

    constructor(props) {
        super(props);

        console.log('ResourceJsx', props)

        this.state = {
            data: props.value
        };

        // console.log('x', props.formProxy.resource['DAILYBREAK'])
        // console.log('props.name', props.name)
        try {
            this.resource = props.formProxy.resource['DAILYBREAK']
            // when we look at resouce the resource id from teh break (pid, pqid) have been translated to 'id'
            this.id = this.resource ? this.resource.id : null 

        } catch(e) {
            console.log(e)
        }

    }

    render() {

        return (

            <div>

                <Grid columns="equal">
                    <Grid.Row className="db-field-label-row">
                        { this.props.field.props.jsx && this.props.field.props.jsx(this.resource)}
                    </Grid.Row>
                </Grid>



            </div>
        )
    }
};

export default catchErrors(ResourceJsx);


// WEBPACK FOOTER //
// ./public/components/forms/CustomFields/ResourceJsx.jsx